import React from 'react';

const TeacherFormPrintView = ({ teacher }) => {
  if (!teacher) return null;

  const today = new Date().toLocaleDateString('en-GB');
  const borderStyle = '1px solid #000';

  return (
    <div className="teacher-form-print-container" style={{ pageBreakAfter: 'always', paddingBottom: '20px' }}>
      <div style={{ width: '100%', fontFamily: 'Arial, sans-serif', color: '#000', boxSizing: 'border-box' }}>
        <div style={{ border: '2px solid #000', display: 'flex', flexDirection: 'column' }}>
          
          {/* Header Info */}
          <div style={{ display: 'flex', borderBottom: borderStyle }}>
            {/* Left Side: Company Info */}
            <div style={{ flex: '1', display: 'flex', gap: '15px', alignItems: 'flex-start', padding: '8px', boxSizing: 'border-box' }}>
              <img src="/image.png" alt="Logo" style={{ width: '60px', height: 'auto', objectFit: 'contain', marginTop: '5px' }} />
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '4px', textTransform: 'uppercase' }}>BK Educational & Welfare Society</div>
                <div style={{ fontSize: '12px', color: '#333' }}>2nd Floor, Gajanan Plaza, Behind Lotus Capital Building,</div>
                <div style={{ fontSize: '12px', color: '#333' }}>Gharpure Ghat Road, Ashok Stambh, Nashik-422002, Maharashtra</div>
                <div style={{ fontSize: '12px', color: '#333' }}>Email : bkgroupofeducation1@gmail.com | Contact No. : 8888301363</div>
                <div style={{ fontSize: '12px', color: '#333' }}>Website : https://www.bkeducation.co.in/</div>
              </div>
            </div>
            
            {/* Right Side: Photo */}
            <div style={{ width: '120px', borderLeft: borderStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}>
              {teacher.photo ? (
                <img src={teacher.photo.startsWith('http') || teacher.photo.startsWith('data:') ? teacher.photo : `${window.location.protocol}//${window.location.hostname}${window.location.protocol === 'https:' ? '' : ':8080'}${teacher.photo}`} alt="Teacher" style={{ width: '100%', height: '120px', objectFit: 'cover', border: '1px solid #ccc' }} />
              ) : (
                <div style={{ width: '100px', height: '120px', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#888', textAlign: 'center' }}>
                  Paste<br/>Recent<br/>Photo<br/>Here
                </div>
              )}
            </div>
          </div>

          {/* Title */}
          <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', borderBottom: borderStyle, padding: '8px 0', background: '#f5f5f5', textTransform: 'uppercase' }}>
            STAFF / TEACHER REGISTRATION FORM
          </div>

          {/* Section: Basic Details */}
          <div style={{ padding: '4px 8px', background: '#eee', borderBottom: borderStyle, fontSize: '12px', fontWeight: 'bold' }}>1. Personal Details</div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Name :</strong> {teacher.name || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Date :</strong> {today}</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Date of Birth :</strong> {teacher.dob || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Gender :</strong> {teacher.gender || ''}</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Aadhar Number :</strong> {teacher.aadhar || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Biometric Reg No :</strong> {teacher.fingerprint_id || ''}</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Email Id :</strong> {teacher.email || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Contact No:</strong> {teacher.studentPhone || teacher.studentContact || ''}</div>
          </div>

          {/* Section: Professional Details */}
          <div style={{ padding: '4px 8px', background: '#eee', borderBottom: borderStyle, fontSize: '12px', fontWeight: 'bold' }}>2. Professional Details</div>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Role :</strong> {teacher.role || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Subject/Profession :</strong> {teacher.role === 'teacher' ? teacher.subject : teacher.profession}</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Experience :</strong> {teacher.experience || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Batch :</strong> {teacher.batch || 'N/A'}</div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', borderBottom: borderStyle }}>
            <div style={{ padding: '6px 8px', borderRight: borderStyle, fontSize: '12px' }}><strong>Timings :</strong> {teacher.timing || ''}</div>
            <div style={{ padding: '6px 8px', fontSize: '12px' }}><strong>Salary :</strong> Rs. {teacher.salary || '0'}</div>
          </div>

          {/* Signatures */}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '50px 20px 20px 20px', marginTop: '20px' }}>
            <div style={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', width: '200px', borderTop: '1px solid #000', paddingTop: '5px' }}>
              Staff Signature
            </div>
            <div style={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', width: '200px', borderTop: '1px solid #000', paddingTop: '5px' }}>
              Admin / HR Signature
            </div>
            <div style={{ textAlign: 'center', fontSize: '12px', fontWeight: 'bold', width: '200px', borderTop: '1px solid #000', paddingTop: '5px' }}>
              Authorized Signatory
            </div>
          </div>

        </div>
      </div>

      <style>{`
        .teacher-form-print-container {
          display: none;
        }
        @media print {
          body.print-receipt .teacher-form-print-container {
            display: none !important;
          }
          body.print-admission .teacher-form-print-container {
            display: none !important;
          }
          body.print-teacher-form * {
            visibility: hidden;
          }
          body.print-teacher-form .teacher-form-print-container, body.print-teacher-form .teacher-form-print-container * {
            visibility: visible;
          }
          .teacher-form-print-container {
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            background: white;
            margin: 0;
            padding: 0;
            page-break-after: always;
          }
        }
      `}</style>
    </div>
  );
};

export default TeacherFormPrintView;
